<template>
  <Btn :label="$t('ELE0123')" icon="mdi-plus" isCheckRole @click="onClick" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnNew',

  components: {
    Btn,
  },

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
